import {CALL_API} from '../../middleware/api';

export const EDITPASSWORD_EDIT_REQUEST = 'EDITPASSWORD_EDIT_REQUEST';
export const EDITPASSWORD_EDIT_SUCCESS = 'EDITPASSWORD_EDIT_SUCCESS';
export const EDITPASSWORD_EDIT_FAILURE = 'EDITPASSWORD_EDIT_FAILURE';

export function editPassword(params) {
  return {
    [CALL_API]: {
      types: [
        EDITPASSWORD_EDIT_REQUEST, EDITPASSWORD_EDIT_SUCCESS, EDITPASSWORD_EDIT_FAILURE
      ],
      endpoint: 'index/update-password',
      methods: 'POST',
      params
    }
  };
}

export default(params) => {
  return (dispatch) => {
    return dispatch(editPassword(params));
  };
};



// WEBPACK FOOTER //
// ./src/action/settings/editPassword.js